module.exports = __webpack_public_path__ + "static/media/pierre.36ea64f7.png";